/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Payments = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 18 18">
      <path
        d="M10.125 10.125C9.5 10.125 8.96875 9.90625 8.53125 9.46875C8.09375 9.03125 7.875 8.5 7.875 7.875C7.875 7.25 8.09375 6.71875 8.53125 6.28125C8.96875 5.84375 9.5 5.625 10.125 5.625C10.75 5.625 11.2812 5.84375 11.7188 6.28125C12.1562 6.71875 12.375 7.25 12.375 7.875C12.375 8.5 12.1562 9.03125 11.7188 9.46875C11.2812 9.90625 10.75 10.125 10.125 10.125ZM4.125 12.75C3.81563 12.75 3.55078 12.6398 3.33047 12.4195C3.11016 12.1992 3 11.9344 3 11.625V4.125C3 3.81563 3.11016 3.55078 3.33047 3.33047C3.55078 3.11016 3.81563 3 4.125 3H16.125C16.4344 3 16.6992 3.11016 16.9195 3.33047C17.1398 3.55078 17.25 3.81563 17.25 4.125V11.625C17.25 11.9344 17.1398 12.1992 16.9195 12.4195C16.6992 12.6398 16.4344 12.75 16.125 12.75H4.125ZM6 11.625H14.25C14.25 11.1 14.4313 10.6563 14.7938 10.2938C15.1563 9.93125 15.6 9.75 16.125 9.75V6C15.6 6 15.1563 5.81875 14.7938 5.45625C14.4313 5.09375 14.25 4.65 14.25 4.125H6C6 4.65 5.81875 5.09375 5.45625 5.45625C5.09375 5.81875 4.65 6 4.125 6V9.75C4.65 9.75 5.09375 9.93125 5.45625 10.2938C5.81875 10.6563 6 11.1 6 11.625ZM15 15H1.875C1.56563 15 1.30078 14.8898 1.08047 14.6695C0.860156 14.4492 0.75 14.1844 0.75 13.875V5.25H1.875V13.875H15V15Z"
        fill="white"
      />
    </BaseSvgIcon>
  )
}

export default Payments
